import { render, staticRenderFns } from "./StartAndEndSchematic.vue?vue&type=template&id=129343a5&scoped=true&"
import script from "./StartAndEndSchematic.vue?vue&type=script&lang=ts&"
export * from "./StartAndEndSchematic.vue?vue&type=script&lang=ts&"
import style0 from "./StartAndEndSchematic.vue?vue&type=style&index=0&id=129343a5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "129343a5",
  null
  
)

export default component.exports